/* ============================================================
   MON CANNELÉ — mc-scripts.js
   À placer dans Assets/ du thème Sense
   ============================================================ */

// ---- VARIANT IDs Shopify ----
const MC_VARIANTS = {
  'box-of-9-mini':          46693917491424,
  'box-of-12-mini-canneles':46693901893856,
  'box-of-18-mini-canneles':46471281606880,
  'box-of-24-mini-canneles':46471295008992,
  'box-of-4-canneles':      46693907628256,
  'box-of-8-canneles':      46693911724256,
  'box-of-12-canneles':     46471325155552,
  'box-of-64-mini':         48475768946912,
};

// ---- LANGUAGE SWITCH ----
const MC_T = {
  en: {
    banner: "Free delivery in Ho Chi Minh City from 500 000 ₫",
    banner_promo: "🌙 MID-AUTUMN OFFER — <strong>15% OFF</strong> all orders from 500 000 ₫ · until Sep 27",
    nav_shop: "Shop", nav_story: "Our Story", nav_b2b: "B2B", cart: "Cart",
    prod_ey: "Our cannelés",
    ingr1: "Vanilla Bourbon", ingr2: "Dark rum", ingr3: "Handcrafted daily",
    s1_lbl: "Step 01", s1_t: "Choose your flavors",
    s2_lbl: "Step 02", s2_t: "Add-ons (optional)",
    opt_r: "Gift ribbon", opt_rd: "+5 000 ₫",
    opt_c: "Gift card",   opt_cd: "Personalized message — +5 000 ₫",
    opt_b: "Separate bag",opt_bd: "Branded gift bag — +5 000 ₫",
    gift_lbl: "Your gift card message", gift_ph: "Write your personalized message here…",
    qty_lbl: "Quantity", atc: "Add to cart",
    warn_fl: "Please select your flavors before adding to cart",
    guar1_lbl: "Handcrafted daily",  guar1_sub: "Fresh every batch",
    guar2_lbl: "Free delivery",      guar2_sub: "From 500 000 ₫",
    guar3_lbl: "Vanilla Bourbon",    guar3_sub: "",
    guar4_lbl: "Dark rum",           guar4_sub: "Authentic Bordeaux recipe",
    related_title: "You might also like",
    f_shop: "Shop", f_all: "All products", f_gifts: "Gift boxes", f_frozen: "Frozen cannelés",
    f_visit: "Visit us", f_days: "Mon–Sun · 9:30–22:00",
    f_contact: "Contact", f_b2b: "B2B enquiries", f_corp: "Corporate gifts",
    f_craft: "Made in Saigon · Since 2020",
  },
  vi: {
    banner: "Giao hàng miễn phí tại TP.HCM từ 500 000 ₫",
    banner_promo: "🌙 ƯU ĐÃI TRUNG THU — <strong>Giảm 15%</strong> mọi đơn từ 500 000 ₫ · đến hết 27/9",
    nav_shop: "Mua sắm", nav_story: "Câu chuyện", nav_b2b: "B2B", cart: "Giỏ hàng",
    prod_ey: "Cannelé của chúng tôi",
    ingr1: "Vanilla Bourbon", ingr2: "Rum đen", ingr3: "Thủ công mỗi ngày",
    s1_lbl: "Bước 01", s1_t: "Chọn hương vị",
    s2_lbl: "Bước 02", s2_t: "Tuỳ chọn thêm (không bắt buộc)",
    opt_r: "Ruy băng quà tặng", opt_rd: "+5 000 ₫",
    opt_c: "Thiệp chúc mừng",   opt_cd: "Lời nhắn cá nhân — +5 000 ₫",
    opt_b: "Túi quà riêng",     opt_bd: "Túi thương hiệu — +5 000 ₫",
    gift_lbl: "Lời nhắn trên thiệp", gift_ph: "Viết lời nhắn cá nhân của bạn tại đây…",
    qty_lbl: "Số lượng", atc: "Thêm vào giỏ hàng",
    warn_fl: "Vui lòng chọn hương vị trước khi thêm vào giỏ",
    guar1_lbl: "Thủ công mỗi ngày", guar1_sub: "Tươi mỗi mẻ bánh",
    guar2_lbl: "Giao hàng miễn phí",guar2_sub: "Từ 500 000 ₫",
    guar3_lbl: "Vanilla Bourbon",   guar3_sub: "",
    guar4_lbl: "Rum đen",           guar4_sub: "Công thức Bordeaux chính gốc",
    related_title: "Bạn có thể thích",
    f_shop: "Mua sắm", f_all: "Tất cả sản phẩm", f_gifts: "Hộp quà", f_frozen: "Cannelé đông lạnh",
    f_visit: "Đến thăm chúng tôi", f_days: "Thứ 2 – CN · 9:30–22:00",
    f_contact: "Liên hệ", f_b2b: "Hợp tác B2B", f_corp: "Quà tặng doanh nghiệp",
    f_craft: "Làm tại Sài Gòn · Từ năm 2020",
  }
};

let MC_LANG = localStorage.getItem('mc_lang') || 'en';

function mcSetLang(l) {
  MC_LANG = l;
  localStorage.setItem('mc_lang', l);
  document.getElementById('mc-btn-en').classList.toggle('act', l === 'en');
  document.getElementById('mc-btn-vi').classList.toggle('act', l === 'vi');
  const t = { ...MC_T.en, ...(MC_T[l] || {}) };
  const banner = document.getElementById('mc-banner');
  // Banner text is handled by header.liquid's own promo-aware script.
  // Only set default here if the promo class isn't active.
  if (banner && !banner.classList.contains('mc-banner-promo')) banner.textContent = t.banner;
  const htmlKeys = ['f_tag'];
  document.querySelectorAll('[data-mc]').forEach(el => {
    const k = el.dataset.mc;
    if (!t[k]) return;
    if (htmlKeys.includes(k)) el.innerHTML = t[k];
    else el.textContent = t[k];
  });
  document.querySelectorAll('[data-mc-ph]').forEach(el => {
    const k = el.dataset.mcPh;
    if (t[k]) el.placeholder = t[k];
  });
  // Update product name, desc, breadcrumb if on product page
  const prodName = document.getElementById('mc-prod-name');
  const prodDesc = document.getElementById('mc-prod-desc');
  const prodBc   = document.getElementById('mc-prod-bc');
  if (window.MC_PROD) {
    if (prodName) prodName.textContent = l === 'vi' ? MC_PROD.name_vi : MC_PROD.name_en;
    if (prodDesc) prodDesc.textContent = l === 'vi' ? MC_PROD.desc_vi : MC_PROD.desc_en;
    if (prodBc)   prodBc.textContent   = l === 'vi' ? MC_PROD.name_vi : MC_PROD.name_en;
  }

  // ---- PATCH : appelle le setLang de la page courante (homepage, panier, etc.) ----
  if (typeof window.setLang === 'function') window.setLang(l);
}

function mcToggleMenu() {
  document.getElementById('mc-mmenu').classList.toggle('open');
}

// ---- FLAVOR SELECTOR ----
let MC_FL = {};
let MC_EXTRA = 0;
let MC_QTY = 1;

function mcGetMax() {
  return window.MC_PROD ? MC_PROD.size : 9;
}

function mcTogFl(el) {
  const f = el.dataset.fl;
  const max = mcGetMax();
  const tot = Object.values(MC_FL).reduce((a, b) => a + b, 0);
  if (!MC_FL[f]) {
    if (tot >= max) return;
    MC_FL[f] = 1;
  } else {
    delete MC_FL[f];
  }
  mcUpdateFlChip(f);
  mcSyncFlCounter();
  mcUpdateTotal();
}

function mcFlQty(e, f, d) {
  e.stopPropagation();
  const max = mcGetMax();
  const tot = Object.values(MC_FL).reduce((a, b) => a + b, 0);
  if (!MC_FL[f]) MC_FL[f] = 0;
  if (d > 0 && tot >= max) return;
  MC_FL[f] = Math.max(0, MC_FL[f] + d);
  if (MC_FL[f] === 0) delete MC_FL[f];
  mcUpdateFlChip(f);
  mcSyncFlCounter();
  mcUpdateTotal();
}

function mcUpdateFlChip(f) {
  const safe = f.replace(/ /g, '-');
  document.querySelectorAll('.mc-fl-chip').forEach(el => {
    if (el.dataset.fl !== f) return;
    el.classList.toggle('sel', !!MC_FL[f]);
    const cnt = document.getElementById('mc-cnt-' + safe);
    const ctrl = document.getElementById('mc-ctrl-' + safe);
    const qsp = document.getElementById('mc-qsp-' + safe);
    if (MC_FL[f]) {
      if (cnt) { cnt.textContent = MC_FL[f]; cnt.classList.add('show'); }
      if (ctrl) ctrl.classList.add('show');
      if (qsp) qsp.textContent = MC_FL[f];
    } else {
      if (cnt) cnt.classList.remove('show');
      if (ctrl) ctrl.classList.remove('show');
    }
  });
}

function mcSyncFlCounter() {
  const tot = Object.values(MC_FL).reduce((a, b) => a + b, 0);
  const max = mcGetMax();
  const cur = document.getElementById('mc-fl-cur');
  if (cur) cur.textContent = tot;
  document.querySelectorAll('.mc-fl-chip').forEach(el => {
    if (!MC_FL[el.dataset.fl]) el.classList.toggle('maxed', tot >= max);
    else el.classList.remove('maxed');
  });
}

// ---- OPTIONS ----
function mcTogOpt(el) {
  setTimeout(() => {
    const cb = el.querySelector('input');
    el.classList.toggle('sel', cb.checked);
    if (el.id === 'mc-opt-giftcard') {
      const gw = document.getElementById('mc-gift-wrap');
      if (gw) gw.classList.toggle('show', cb.checked);
    }
    MC_EXTRA = 0;
    document.querySelectorAll('.mc-opt.sel').forEach(o => {
      MC_EXTRA += parseInt(o.dataset.cost || 0);
    });
    mcUpdateTotal();
  }, 0);
}

// ---- QTY ----
function mcChQty(d) {
  const inp = document.getElementById('mc-qty');
  MC_QTY = Math.max(1, Math.min(99, (parseInt(inp.value) || 1) + d));
  inp.value = MC_QTY;
  mcUpdateTotal();
  mcUpdSeparateBag();
}
function mcOnQty(el) {
  MC_QTY = Math.max(1, Math.min(99, parseInt(el.value) || 1));
  el.value = MC_QTY;
  mcUpdateTotal();
  mcUpdSeparateBag();
}

// ---- SEPARATE BAG: visible si panier non-vide OU MC_QTY >= 2 ----
let mcCartBoxCount = 0;

function mcLoadCartBoxCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const ADDON_NAMES = ['Gift Ribbon', 'Gift Card', 'Separate Bag'];
      mcCartBoxCount = cart.items
        .filter(i => !ADDON_NAMES.includes(i.product_title))
        .reduce((a, i) => a + i.quantity, 0);
      mcUpdSeparateBag();
    })
    .catch(() => { mcCartBoxCount = 0; mcUpdSeparateBag(); });
}

function mcUpdSeparateBag() {
  const bagOpt = document.querySelector('.mc-opt[data-key-name="Separate bag"]');
  if (!bagOpt) return;
  const shouldShow = MC_QTY >= 2 || mcCartBoxCount >= 1;
  if (!shouldShow) {
    bagOpt.style.display = 'none';
    const cb = bagOpt.querySelector('input[type="checkbox"]');
    if (cb && cb.checked) {
      cb.checked = false;
      bagOpt.classList.remove('sel');
      MC_EXTRA = 0;
      document.querySelectorAll('.mc-opt.sel').forEach(o => MC_EXTRA += parseInt(o.dataset.cost || 0));
      mcUpdateTotal();
    }
  } else {
    bagOpt.style.display = '';
  }
}

// ---- PRICE ----
function mcFmt(n) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₫';
}
function mcUpdateTotal() {
  if (!window.MC_PROD) return;
  const unit = MC_PROD.price + MC_EXTRA;
  const el = document.getElementById('mc-total-price');
  const up = document.getElementById('mc-unit-price');
  if (el) el.textContent = mcFmt(unit * MC_QTY);
  if (up) up.textContent = mcFmt(unit) + (MC_QTY > 1 ? ' × ' + MC_QTY : '');
}

// ---- ADD TO CART (Shopify Cart API) ----
function mcAddToCart() {
  const tot = Object.values(MC_FL).reduce((a, b) => a + b, 0);
  const max = mcGetMax();
  const warn = document.getElementById('mc-prod-warn');

  // Must fill ALL flavor slots
  if (tot < max) {
    if (warn) {
      warn.textContent = MC_LANG === 'vi'
        ? `Vui lòng chọn đủ ${max} hương vị — ${tot}/${max} đã chọn`
        : `Please select all ${max} flavors — ${tot}/${max} selected`;
      warn.style.display = 'block';
      setTimeout(() => warn.style.display = 'none', 3500);
    }
    return;
  }
  if (warn) warn.style.display = 'none';

  const properties = {};
  Object.entries(MC_FL).forEach(([f, c]) => properties[f] = '× ' + c);
  document.querySelectorAll('.mc-opt.sel').forEach(o => {
    properties[o.dataset.keyName] = 'Yes';
  });
  const giftMsg = document.getElementById('mc-gift-ta');
  if (giftMsg && giftMsg.value.trim()) {
    properties['Gift card message'] = giftMsg.value.trim();
  }

  const btn = document.getElementById('mc-atc-btn');
  if (btn) { btn.disabled = true; btn.textContent = '...'; }

  // Use variant_id directly from MC_PROD (set in main-product.liquid by Liquid)
  const variantId = MC_PROD.variant_id;

  // Add-on Shopify variant IDs (for correct pricing as separate line items)
  const ADDON_IDS = {
    'Gift ribbon':  52953554288864,
    'Gift card':    52953555075296,
    'Separate bag': 52953556025568
  };

  // Main box item (with flavors + add-on properties)
  const items = [{
    id: variantId,
    quantity: MC_QTY,
    properties: properties
  }];

  // Add-on products as separate line items for pricing
  document.querySelectorAll('.mc-opt.sel').forEach(o => {
    const addonId = ADDON_IDS[o.dataset.keyName];
    if (addonId) items.push({ id: addonId, quantity: MC_QTY });
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
  .then(r => r.json())
  .then(data => {
    if (data.status) {
      console.error('Cart error:', data);
      if (btn) { btn.disabled = false; btn.textContent = MC_T[MC_LANG].atc; }
    } else {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const boxCount = cart.items
          .filter(i => !_ADDON_PROD_NAMES.includes(i.product_title))
          .reduce((a, i) => a + i.quantity, 0);
        const countEl = document.getElementById('mc-cart-count');
        if (countEl) countEl.textContent = boxCount || '';
      });
      window.location.href = '/cart';
    }
  })
  .catch(err => {
    console.error('Cart error:', err);
    if (btn) { btn.disabled = false; btn.textContent = MC_T[MC_LANG].atc; }
  });
}

// ---- REFRESH CART COUNT (boxes only, not add-ons) ----
const _ADDON_PROD_NAMES = ['Gift Ribbon', 'Gift Card', 'Separate Bag'];

function mcRefreshCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const boxCount = cart.items
        .filter(i => !_ADDON_PROD_NAMES.includes(i.product_title))
        .reduce((a, i) => a + i.quantity, 0);
      const countEl = document.getElementById('mc-cart-count');
      if (countEl) countEl.textContent = boxCount || '';
    })
    .catch(() => {});
}
window.mcRefreshCartCount = mcRefreshCartCount;

// ---- INIT ----
document.addEventListener('DOMContentLoaded', () => {
  mcSetLang(MC_LANG);
  mcUpdateTotal();
  mcLoadCartBoxCount();
  mcRefreshCartCount(); // update header badge on every page load
});